const CONTROL_PANEL_TABS = [
  {
    key: 'brand',
    label: 'Brand',
    hiddenForConsulente: true,
  },
  {
    key: 'gruppi',
    label: 'Gruppi',
    hiddenForConsulente: true,
  },
  {
    key: 'responsabili_sicurezza',
    label: 'Responsabili sicurezza',
  },
  {
    key: 'consulenti',
    label: ({ isConsulente }) => (isConsulente ? 'Consulente' : 'Consulenti'),
  },
  {
    key: 'esercizi_commerciali',
    label: 'Esercizi commerciali',
  },
  {
    key: 'modelli_manuali',
    label: 'Modelli di manuali',
  },
  {
    key: 'manuali',
    label: 'Manuali sicurezza',
  },
  {
    key: 'abbonamenti',
    label: 'Abbonamenti',
    hiddenForConsulente: true,
  },
  {
    key: 'clienti',
    label: 'Clienti',
  },
];

// Tabs listed here appear only where REACT_APP_PREVIEW_TABS names them, so an
// environment that does not name a key never renders the tab and never routes to
// it. The polarity is opt-in on purpose: an environment whose configuration is
// missing or empty keeps the tab hidden.
const PREVIEW_ONLY_TABS = ['clienti'];

// Read as a value and never compared against a literal: in a production build
// process.env is inlined at build time and the container substitutes the
// placeholder afterwards, so a string comparison here would be constant-folded
// away before that substitution can happen.
const previewTabs = (process.env.REACT_APP_PREVIEW_TABS || '')
  .split(',')
  .map((tab) => tab.trim())
  .filter(Boolean);

const ENABLED_CONTROL_PANEL_TABS = CONTROL_PANEL_TABS.filter(
  (tab) =>
    !PREVIEW_ONLY_TABS.includes(tab.key) || previewTabs.includes(tab.key),
);

export const validTabs = ENABLED_CONTROL_PANEL_TABS.map((tab) => tab.key);

export function getVisibleControlPanelTabs({ isConsulente }) {
  return ENABLED_CONTROL_PANEL_TABS.filter(
    (tab) => !(tab.hiddenForConsulente && isConsulente),
  ).map((tab) => ({
    ...tab,
    label:
      typeof tab.label === 'function' ? tab.label({ isConsulente }) : tab.label,
    to: `/amministrazione/${tab.key}`,
  }));
}

export function isAdminPath(pathname) {
  return pathname.startsWith('/amministrazione');
}

export function getCurrentAdminSection(pathname) {
  const matches = pathname.match(/\/amministrazione\/([^/]+)/);
  const currentSection = matches ? matches[1] : null;

  if (validTabs.includes(currentSection)) {
    return currentSection;
  }

  if (pathname.startsWith('/amministrazione/edit_template')) {
    return 'brand';
  }

  if (
    pathname.startsWith('/amministrazione/dettaglioProcedura') ||
    pathname.startsWith('/amministrazione/schedaProcedura')
  ) {
    return 'manuali';
  }

  return null;
}
